import { render } from "./TrainingSetting.vue?vue&type=template&id=5ead4fc1&ts=true"
import script from "./TrainingSetting.vue?vue&type=script&lang=ts"
export * from "./TrainingSetting.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__